import { toast } from 'react-toastify';

export const toastError = (msg: string) => {
  toast.error(msg, {
    position: 'top-center',
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const toastSuccess = (msg: string) => {
  toast.success(msg, {
    position: 'top-center',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const toastApiError = (error: Error | null) => {
  if (error) {
    const msgs: string[] = (error as any).response.data.errors || [];
    if (msgs.length > 0) toastError(msgs[0]);
  }
};
